module.exports = __webpack_public_path__ + "img/glasses-8-5.a2df26f4.svg";